import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PharosApiResponse, TenantProfile } from '@klareospace/pharos-lib-types';

export function createTenantProfileApi(client: ApiClient): {
  getTenantProfile: () => Promise<TenantProfile>;
} {
  return {
    getTenantProfile: async (): Promise<TenantProfile> => {
      const response = await client.execute<PharosApiResponse<TenantProfile>>(() => client.instance.get('/tenants/me'));
      if (!response.data) throw new Error('getTenantProfile: unexpected empty response');
      return response.data;
    },
  };
}
